export type MentionQuery = { start: number; end: number; query: string };

/**
 * Where the caret sits inside an `@` mention being typed, or null.
 *
 * The boundary rule is the one `mentionedUsernames` applies when a mention is persisted: the `@`
 * may follow the start of the text or any character outside `[A-Za-z0-9_@]`, so `review,@lead`
 * offers a menu while `me@example.com` does not. Keeping both sides on one rule means every
 * mention the composer offers is one the server will notify.
 */
export function mentionQueryAt(text: string, caret: number): MentionQuery | null {
  const before = text.slice(0, caret);
  const match = before.match(/(^|[^A-Za-z0-9_@])@([A-Za-z0-9._-]*)$/);
  if (!match) return null;
  const query = match[2]!;
  return { start: caret - query.length - 1, end: caret, query: query.toLowerCase() };
}
